import * as React from "react";
import { TextBox } from "../../forms/informedv2/TextBox";
import { DeviceType } from "webportalclient";
import { DeviceTypes } from "../../misc/api/apiTypes";
import { Checkbox } from "informed";
export interface StudySettingsFromModel {
    Spirotrac6PackageName: string;
    Spirotrac6OverreadingEnabled: boolean;

}


export interface StudySettingsFromProps {
    deviceTypes: DeviceType[];
}


export const StudySettingsFrom = ({ deviceTypes }: StudySettingsFromProps) => {
    return deviceTypes.some(e => e.id == DeviceTypes.Spirotrac6) ? (

        <>
            <div className="row">
                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                    <label htmlFor="Name">Spirotrac 6 Package Name</label>
                    <TextBox<number, StudySettingsFromModel>
                        id="Spirotrac6PackageName"
                        field="Spirotrac6PackageName"
                    />
                </div>
                <div className="form-group col-md-6">
                    <label>Over-Read enabled</label>
                    <p></p>
                    <Checkbox<boolean, StudySettingsFromModel> id="Spirotrac6OverreadingEnabled" field="Spirotrac6OverreadingEnabled" />
                </div>
            </div>
        </>
    ) : <></>;
}
